module.exports = "https://static.im-cdn.com/mjc/storefront/Bright/static/media/LChevron1.0533d7de.svg";